exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-result-container[data-v-2cf2097c]{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin:auto;max-width:1200px}.search-result-container .product-card-search[data-v-2cf2097c]{margin:0 13px 80px}.search-result-container .num-items[data-v-2cf2097c]{margin-bottom:20px}.search-result-container .num-items .reset-filter[data-v-2cf2097c]{text-decoration:underline}", ""]);

// exports
